import React from 'react';
import { Trans } from '../../../components/common';
import ServiceIcon from '../../../components/common/ServiceIcon/ServiceIcon';
import SummaryCard from '../../../components/common/Cards/SummaryCard/SummaryCard';

// Props: account, agency, ... (add more as needed)
const TXRCSummaryCard = ({ account, agency }) => (
  <SummaryCard
    key={account.name}
    className="summary-card-txrc card-flat"
    outlined={false}
    graphic={
      <ServiceIcon
        className="agency-linked-services-item-icon flex-item"
        type="driver-license"
      />
    }
    horizontalList={true}
  >
    <div className="vehicle-details-txrc">
      <SummaryCard.List
        fullWidth
        items={[
          {
            label: <Trans file="Labels" id="txrc_name" />,
            value: account.name,
          },
          {
            label: <Trans file="Labels" id="txrc_licenseType" />,
            value: account.licenseType,
          },
        ]}
      />
      <SummaryCard.List
        className={`${agency.agencySlug}`}
        fullWidth
        items={[
          {
            label: <Trans file="Labels" id="txrc_licenseNumber" />,
            value: account.licenseNumber,
          },
        ]}
      />
    </div>
  </SummaryCard>
);

export default TXRCSummaryCard;
